<div class="container-fluid padMob webView " style="padding-left: 20px; padding-right: 15px;" #epltable>
  <div class="row">
    <div class="col-md-12 col-12 col-sm-12   padHeder" style="padding-bottom: 15px;">
      <div class="col-md-2 col-12 col-sm-12 pad0 inLneBlk">
        <h2  class="lblHeader newHeader"> Inventory</h2>
      </div>
      <div class="col-md-10 col-12 col-sm-12 pad0 inLneBlk txtRight">
        <div class="input-icons search" style="display: inline-block; width: 100%;">
          <span>
            <i class="fa fa-search" style="left: 27px !important;top: -2px; color: #999;"></i>
            <!-- <span class="fa fa-search" style="color: blue"  *ngIf="Items.length != 0"></span> -->
            <input class="form-control formCtlFltr bgwhite" ng-model="search.term" placeholder="Search" matInput
              (keyup)="applyFilter($event)" #input
              style="text-align: left; margin-left: 7px; display: inline-block; border-radius: 3px !important;
              box-shadow: none; width: 18%;  font-size: 13px; height: 32px !important;
              text-indent: 25px;"
              type="text">
          </span>
          <!-- <span class="label orangeBadge-wb fntSz"
            style="padding: 5px 7px; margin-left: 7px; border-radius: 3px; background: #fff; border: 1px solid; color: 4caf50;"
            *ngIf="Items.length  > 0"><span>
              Total Items : {{Items.length | lacFormat:0 }}</span>
          </span>
          <span class="label orangeBadge-wb fntSz"
            style="padding: 5px 7px; margin-left: 7px; border-radius: 3px; background: #fff; border: 1px solid; color: 4caf50;" 
            *ngIf="totalValue > 0 && isRateView">₹
            {{totalValue | lacFormat : 0}}</span> -->
          <span *ngIf="right.InvXns" style="margin-left: 7px;"><span class="btn orangeButton"
              (click)="openTransaction(0)"
              style=" font-size: 13px !important; color:#fff; border-radius: 3px;">
              <span style="margin-right: 5px;"><i class="fa fa-sign-out" aria-hidden="true"
                  style="font-size: 16px; position: relative; top: 1px;"></i></span><span>Out / Issue</span></span>
          </span>
          <span *ngIf="right.InvXns" style="margin-left: 7px;"><span class="btn orangeButton"
            (click)="openTransaction(1)"
            style="font-size: 13px !important; color:#fff; border-radius: 3px;">
            <span style="margin-right: 5px;">
              <i class="fa fa-sign-in" aria-hidden="true"
              style="font-size: 16px; position: relative; top: 1px;"></i></span> <span>In / Receive</span></span></span>
          <span *ngIf="right.InvMstrs">
            <span class="btn orangeButton" (click)="open(mymodal)"
                style="margin-left: 7px;font-size: 13px !important; color:#fff; border-radius: 3px;"><i
                  class="zmdi zmdi-plus" aria-hidden="true" style="position: relative; top: 0px; font-size: 16px"></i>
                <span style="margin-left: 7px;">Add Item</span>
            </span>
          </span>
          <span *ngIf="right.InvMstrs" (click)="importItems(itemimport)" class="btn darkBlueButton" title="Import Items"
            style="cursor: pointer; margin-left: 7px; line-height: 19px; padding: 5px 9px !important;">
            <i class="zmdi zmdi-arrow-left-bottom" aria-hidden="true" style="padding-right: 5px; font-weight: bold;"></i> 
            <span>Import Items</span>
          </span>
          <span *ngIf="fullInvRights && (Items.length > 0)" class="btn darkBlueButton fntSz"
                  (click)="exportToExcelActivities()" title="Export to Excel"
                  style="cursor: pointer; margin-left: 7px; line-height: 19px; padding: 5px 8px !important;">
                  <span><i class="fa fa-file-excel-o" aria-hidden="true"></i></span></span>
          <span class="btn darkBlueButton fntSz" *ngIf="right.InvCfg" [routerLink]="['/Settings']" title="Settings"
                  style="cursor: pointer; margin-left: 7px; line-height: 19px; padding: 5px 8px !important;"><span><i
                      class="fa fa-cog" aria-hidden="true"></i></span>
                </span>
          <a class="btn darkBlueButton fntSz" *ngIf="right.InvRpts" [routerLink]="['/InvReport']" target="{{isWeb ? '_blank' : '_self'}}"
                title="Reports"
                style="cursor: pointer; margin-left: 7px; line-height: 19px;padding: 5px 6px !important;">
                <span><i class="fa fa-line-chart" aria-hidden="true"></i></span>
              </a>
          <!-- <span class="btn darkBlueButton fntSz" (click)="opentagSearch(tagSearch)" title="Filter"
              style="cursor: pointer; margin-left: 7px; line-height: 19px; padding: 5px 8px !important;">
              <span><i class="fa fa-filter" aria-hidden="true"></i></span>
          </span> -->
          
          <span [routerLink]="['/StockExpand']" *ngIf="fullInvRights" class="btn darkBlueButton" title="Expand"
            style="cursor: pointer; margin-left: 5px; line-height: 19px; padding: 5px 8px !important;">
            <span><i class="fa fa-expand" aria-hidden="true"></i></span>
          </span>
        </div>
        <div class="input-icons search" style="display: none; float: right; width: 100%;">
          <span>
            <i class="fa fa-search" style="color: red;"></i>
            <!-- <span class="fa fa-search" style="color: blue"  *ngIf="Items.length != 0"></span> -->
            <input class="form-control brdrColor searchBar" ng-model="search.term" placeholder="Search" matInput
              (keyup)="applyFilter($event)" #input
              style="border: 1px solid #BCC2C9 !important; text-align: left; margin-right: 10px; display: inline-block; padding-left: 35px !important; padding: 2px; border-radius: 25px !important; box-shadow: none; width: 18%; font-size: 13px; height: 34.4px;"
              type="text">
          </span>

          <span [routerLink]="['/StockExpand']" *ngIf="fullInvRights" class="btn btn-orange" title="Expand"
            style="cursor: pointer; margin-left: 10px; line-height: 23px; float: right; padding: 5px 8px !important;"><span><i
              class="fa fa-expand" aria-hidden="true"></i></span>
          </span>

          <span *ngIf="right.InvMstrs" (click)="importItems(itemimport)" class="btn btn-yellow" title="Import Items"
            style="cursor: pointer; margin-left: 10px; line-height: 23px; float: right; padding: 5px 9px !important; font-size: 14px;"><span>
              <i class="zmdi zmdi-arrow-left-bottom" aria-hidden="true"></i></span>
          </span>
          
          <span class="btn btn-green fntSz" (click)="opentagSearch(tagSearch)" title="Filter"
            style="cursor: pointer; margin-left: 10px; line-height: 23px; float: right; padding: 5px 9px !important; font-size: 13px;">
            <span><i class="fa fa-filter" aria-hidden="true"></i></span>
          </span>

         
        
          <!-- <a class="btn btn-blue fntSz" [routerLink]="['/InvReport']" target="_blank" title="Reports"
            style="cursor:pointer;margin-left: 10px;line-height: 23px; float: right; padding: 5px 9px;">
            <span><i class="fa fa-line-chart" aria-hidden="true"></i></span>
        </a> -->

          <a class="btn btn-teal fntSz" *ngIf="right.InvRpts" [routerLink]="['/InvReport']" target="{{isWeb ? '_blank' : '_self'}}"
            title="Reports"
            style="cursor: pointer; margin-left: 10px; line-height: 23px; float: right; padding: 5px 7px !important; font-size: 11px;">
            <span><i class="fa fa-line-chart" aria-hidden="true"></i></span>
          </a>

          <span class="btn btn-blue fntSz" *ngIf="right.InvCfg" [routerLink]="['/Settings']" title="Settings"
            style="cursor: pointer; margin-left: 10px; line-height: 23px; float: right; padding: 5px 8px !important;"><span><i
                class="fa fa-cog" aria-hidden="true"></i></span>
          </span>

          <span *ngIf="fullInvRights && (Items.length > 0)" class="btn btn-darkBlue fntSz"
            (click)="exportToExcelActivities()" title="Export to Excel"
            style="cursor: pointer; margin-left: 10px; line-height: 23px; float: right; padding: 5px 8px !important;"><span><i
                class="fa fa-file-excel-o" aria-hidden="true"></i></span></span>

          <span *ngIf="right.InvMstrs" style="float: right;"><span class="btn btn-brown" (click)="open(mymodal)"
              style="line-height: 33px !important; padding: 0px 10px; font-size: 13px !important; color:#fff; border-radius: 25px;"><i
                class="zmdi zmdi-plus" aria-hidden="true" style="position: relative; top: 0px; font-size: 16px"></i>
              <span style="margin-left: 5px;">Add Item</span></span></span>
           
          <span *ngIf="right.InvXns" style="float: right; margin-right: 10px;"><span class="btn btn-orange"
              (click)="openTransaction(1)"
              style="line-height: 33px !important; padding: 5px 10px; font-size: 13px !important; color:#fff; border-radius: 25px; padding: 0px 15px;">
              <span style="margin-right: 8px;">
                <i class="fa fa-sign-in" aria-hidden="true"
                style="font-size: 16px; position: relative; top: 1px;"></i></span> <span>In / Receive</span></span></span>

        

          <span *ngIf="right.InvXns" style="float: right; margin-right: 10px;">
            <span class="btn btn-yellow" (click)="openTransaction(0)"
              style="line-height: 33px !important; padding: 5px 10px; font-size: 13px !important; color:#fff; border-radius: 25px; padding: 0px 15px;">
              <span style="margin-right: 5px;">
                <i class="fa fa-sign-out" aria-hidden="true" style="font-size: 16px; position: relative; top: 1px;"></i>
              </span><span>Out / Issue</span>
            </span>
          </span>

        </div>
      </div>
    </div>

    <div class="col-md-12 col-12 col-sm-12 padHeder" style="padding-top: 0px; padding-bottom: 0px; padding-right: 15px;">
      <span class="label brownBadge-wb fntSz brdrRadius3 {{filter == 0 ? 'brownBadge-wb-active' : ''}}" (click)="typeFilter(0)"
        style="cursor: pointer; margin-left: 0px;"><span>All</span></span>
      <span class="label greenBadge-wb fntSz brdrRadius3 {{filter == 1 ? 'greenBadge-wb-active' : ''}}" (click)="typeFilter(1)"
        style="cursor: pointer; margin-left: 5px;"><span style="margin-right: 5px"><i class="fa fa-square"
            aria-hidden="true"></i></span> <span>Products</span></span>
      <span class="label orangeBadge-wb fntSz brdrRadius3 {{filter == 2 ? 'orangeBadge-wb-active' : ''}}" (click)="typeFilter(2)"
        style="cursor: pointer; margin-left: 5px;"><span style="margin-right: 5px"><i class="fa fa-square"
            aria-hidden="true"></i></span> <span>Materials</span></span>
      <span class="label darkBlueBadge-wb fntSz brdrRadius3 {{filter == 3 ? 'darkBlueBadge-wb-active' : ''}}" (click)="typeFilter(3)"
        style="cursor: pointer; margin-left: 5px"><i class="fa fa-square" aria-hidden="true"></i><span
          style="margin-left: 5px">Spares</span></span>
      <span class="label blueBadge-wb fntSz brdrRadius3 {{filter == 4 ? 'blueBadge-wb-active' : ''}}" (click)="typeFilter(4)"
        style="cursor: pointer; margin-left: 5px; margin-right: 5px;"><span style="margin-right: 5px"><i class="fa fa-square"
            aria-hidden="true"></i></span><span>Assemblies</span></span>
      <!-- <span class="label yellowBadge fntSz {{filter == 3 ? 'activeYellow' : ''}}" (click)="typeFilter(3)"
        style="cursor:pointer;margin-left:5px; "><span style="margin-right:5px"><i class="fa fa-square"
            aria-hidden="true"></i></span><span>Services</span></span> -->
      <span style="float: right;">
        <span class="label orangeBadge-wb fntSz" style="padding: 5px 7px; margin-left: 7px; border-radius: 3px; float: right; background: #fff; border: 1px solid; color: 4caf50;"
        *ngIf="ValnMethod == 1 || ValnMethod == 2 || ValnMethod == 3">
          <span>
            Valuation : {{ValnMethod == 1 ? 'Standard Cost' : (ValnMethod == 2 ? 'Last Purchase Price' : (ValnMethod == 3 ? 'Historical Average' : ''))}}
          </span>
        </span>
        <span class="label orangeBadge-wb fntSz"
          style="padding: 5px 7px; margin-left: 7px; border-radius: 3px; background: #fff; border: 1px solid; color: 4caf50;"
          *ngIf="Items.length  > 0"><span>
            Total Items : {{Items.length | lacFormat:0 }}</span>
        </span>
      <span class="label orangeBadge-wb fntSz"
        style="padding: 5px 7px; margin-left: 7px; border-radius: 3px; background: #fff; border: 1px solid; color: 4caf50;" 
        *ngIf="totalValue > 0 && isRateView">₹
        {{totalValue | lacFormat : 0}}</span>
      </span>
            

      <div class="col-sm-12 col-md-12 col-xs-12 pad0" style="display: flex; align-items: center; column-gap: 8px; margin-top: 15px;">
        <!-- All Stores -->
        <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 50%; max-width: 150px;" 
        [(ngModel)]="storeId" (change)="changeStore()" *ngIf="cntAllStores > 1">
          <option value="0" *ngIf="storeList.length == cntAllStores">All Stores</option>
          <option *ngFor="let s of storeList" [ngValue]="s.StrID">{{s.sNm}}</option>
        </select>
        <!-- Category -->
        <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 50%; max-width: 150px;" id="txtItem" [(ngModel)]="data.categoryID" tabindex="1" (change)="filterCategory()">
          <option [value]="0">All Categories</option>
          <option *ngFor="let a of categories" [value]="a.cid">{{a.cnm}}</option>
        </select>
        <!-- Sub Category -->
        <select [disabled]="subCategoryList.length == 0" class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 50%; max-width: 150px;" [(ngModel)]="data.SubCategoryID" tabindex="1" (change)="filterSubCategory()">
          <option [value]="0">All Sub Categories</option>
          <option *ngFor="let x of subCategoryList" [value]="x.sid">{{x.snm}}</option>
        </select>
        <!-- All Stocks -->
        <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 150px;" [(ngModel)]="selected.stockType" tabindex="1" (change)="filterStockItems()">
          <option [value]="0">All Non-Zero Stock</option>
          <option [value]="1" >All Stock Items</option>
          <option [value]="2" >Understock Items Only</option>
        </select>
        <!-- Importance -->
        <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 150px;" [(ngModel)]="selected.imp" (change)="typeFilter(6)">
          <option value="3">All Importance Levels</option>
          <option value="0">Low</option>
          <option value="2">Normal</option>
          <option value="1">High</option>
        </select>
        <!--Activity Status-->

        <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 150px;" 
       
        [(ngModel)]="selectedStatus"
        (change)="typeFilter(selected.stockType)"
      >
        <option value="all">All Items</option>
        <option value="active">Active Items</option>
        <option value="inactive">Inactive Items</option>
      </select>
      
      
        <!-- Tags -->
        <input type="text" class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" list="Tags" placeholder="Search by Tag" style="display: inline-block; width: 15%; background-color: white !important;" [(ngModel)]="itemTag.search">
        <datalist id="Tags" tabindex="1">
          <option *ngFor="let i of tag" value="{{i}}">
        </datalist>
        <!-- <div>
          <i class="zmdi zmdi-plus orangeText"
          style="font-size: 20px; vertical-align: middle; cursor: pointer;"
          (click)="getTagSearchData(1)"></i>
        </div> -->
        <span class="greenBadge brdrRadius3" style="cursor: pointer; line-height: 20px; padding: 5px 10px;" (click)="filterApply()">
          <i class="zmdi zmdi-check"></i>
        </span>
        <span class="btn darkBlueButton" (click)="clearAllFilters()" *ngIf="getFilterCount() > 0">
          <i class="zmdi zmdi-close mr5" style="margin: 0px 5px;"></i> Clear Filters
        </span>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="selectedTags.length>0" style="display: flex; justify-items: start; flex-wrap: wrap; column-gap: 8px; row-gap: 4px; margin-top: 15px; padding-left: 0; padding-right: 0;">
        <div style="display: inline-block; border: 1px solid #ddd; padding: 3px 10px; font-size: 13px; border-radius: 3px; background:rgb(31 98 142 / 10%) !important; color:#15304a" *ngFor="let x of selectedTags; let i = index">
          <span>{{x}}</span>
          <span style="margin-left: 5px; cursor: pointer;" (click)="removeTagSearchNew(i)">
            <i class="zmdi zmdi-close"></i>
          </span>
        </div>
      </div>
    </div>
    <!-- <div class="col-md-6 col-12 col-sm-12 pad0 padHeder " style="padding: 0px 15px 0px 0px; text-align: right;"> -->
      <!-- <span class="btn-blue" style="display: none; font-size: 13px; display: inline-block; padding: 5px 12px 6px; ;
        margin-left: 10px;margin-right: 10px;" [routerLink]="['/StockExpand']">
          <i class="fa fa-expand" style="margin-right: 3px;"></i> Expand
      </span> -->

      <!-- <span class="label darkBlueBadge fntSz bgwhite darkBlueBrdr brdrRadius3" style="padding: 4px 8px !important; line-height: 18px; cursor: pointer; margin-right: 8px;" title="Store"
        *ngIf="cntAllStores > 1" (click)="selectStore(storeSelect)"> <span style="font-size: 14px; margin-right: 8px;">
          <i class="zmdi zmdi-store"></i></span>{{storeName}}
      </span> -->

      <!-- <span class="label darkBlueBadge fntSz bgwhite darkBlueBrdr brdrRadius3" style="padding: 4px 8px !important; cursor: pointer;margin-right: 8px;" *ngIf="!zeroQtyItems && allStoreRights"><label
          style="margin-bottom: 0px; cursor: pointer; vertical-align: middle;">
          <input class="chkbox-darkblue" type="checkbox" (change)="filterDepleted()" [(ngModel)]="depletedItems"
            style="vertical-align: text-top; position: relative; top: 1px;"> Show Depleted
          Items</label></span> -->
      <!-- <span class="label darkBlueBadge fntSz bgwhite darkBlueBrdr brdrRadius3" style="padding: 4px 8px !important; cursor: pointer;" *ngIf="!depletedItems && allStoreRights"> <label
          style="margin-bottom: 0px; cursor: pointer;"><input class="chkbox-darkblue" type="checkbox" (change)="filterIncludeZeroqty()"
            [(ngModel)]="zeroQtyItems" style="vertical-align: text-top; position: relative; top: 1px;"> Include Zero Qty
          Items </label></span> -->
    <!-- </div> -->

    <div *ngIf="showItemList" class="col-md-12 col-12 col-sm-12 pad0" style="padding: 15px; margin-top: 15px;">
      <div class="col-md-12 col-12 col-sm-12 pad0 bzMatTbl shadow">
        <table mat-table [dataSource]="dataSource" matSort style="width: 100%; border-radius: 3px;">
          <ng-container matColumnDef="ItemName">
            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
              Item
              <!-- <div class="filter" floatLabel="never" style="width: 20%;display: none;">
                <input matInput class="form-control seachInput" [formControl]="ItemNameFilter" placeholder="Group"
                  style="border: none; border-bottom: 1px solid; font-size: 14px;">
              </div> -->
            </th>
            <td mat-cell *matCellDef="let item" style="width: 25%; text-align: left;">
              <div class="inLneBlk" style="width: 90%; cursor: pointer;" (click)="openItemEidt(productEdit, item);">
                {{item.ItemName}} </div>
              <div class="inLneBlk" style="width: 10%;">
                <i class="fa fa-square" aria-hidden="true" style="color:#e88421" [hidden]="item.TypeID != 2 "
                  title="Material"></i>
                <!-- <i class="fa fa-square" aria-hidden="true" style="color:#DAA520" [hidden]="item.TypeID != 3"
                  title="Service"></i> -->
                <i class="fa fa-square" aria-hidden="true" style="color:#2b7fb3" [hidden]="item.TypeID != 4"
                  title="Assembly"></i>
                <i class="fa fa-square" aria-hidden="true" style="color:#4caf50" [hidden]="item.TypeID != 1"
                  title="Product"></i>
                <i class="fa fa-square" aria-hidden="true" style="color:#15304a" [hidden]="item.TypeID != 3"
                  title="Spare"></i>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="ItemCode">
            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
              <label style="cursor: pointer;">Code</label>
              <div class="filter" floatLabel="never" style="display: none;">
                <input matInput class="form-control seachInput" [formControl]="ItemCodeFilter" placeholder="Opening"
                  style="border: none; border-bottom: 1px solid; width: 120px; font-size: 14px;">
              </div>
            </th>
            <td mat-cell *matCellDef="let item" style="text-align: left; width: 12%; cursor: pointer;"
              (click)="openItemEidt(productEdit, item);">{{item.ItemCode }}</td>
          </ng-container>

          <ng-container matColumnDef="Imp">
            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
              <label style="cursor: pointer;">Importance</label>
              <div class="filter" floatLabel="never" style="display: none;">
                <input matInput class="form-control seachInput" [formControl]="ImpFilter" placeholder="Importance"
                  style="border: none; border-bottom: 1px solid; width: 120px; font-size: 14px;">
              </div>
            </th>
            <td mat-cell *matCellDef="let item" style="text-align: left; width: 12%; cursor: pointer;"
              (click)="openItemEidt(productEdit, item);">{{ item.ImpName }}</td>
          </ng-container>

          <ng-container matColumnDef="SCN">
            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
              <label style="cursor: pointer;">Category</label>
              <div class="filter" floatLabel="never" style="display: none;">
                <input matInput class="form-control seachInput" [formControl]="CategoryFilter" placeholder="Debit"
                  style="border: none; border-bottom: 1px solid; width: 120px; font-size: 14px;">
              </div>
            </th>
            <!-- <td mat-cell *matCellDef="let item" style="text-align: left; width: 20%;">{{item.CategoryName == '' ? "-" : item.CategoryName }} 
              <span *ngIf="item.SubCategoryName"> / </span> {{item.SubCategoryName}}
            </td> -->
            <td mat-cell *matCellDef="let item" style="text-align: left; width: 20%; cursor: pointer;"
              (click)="openItemEidt(productEdit, item);">
              {{ item.SCN }}
            </td>
          </ng-container>
          <ng-container matColumnDef="CurrQty">
            <th class="header header-Table" [style.padding-left]="(isRateView ? '5%' : '12%')" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
              <label style="cursor: pointer;">Qty</label>
              <div class="filter" floatLabel="never" style="display: none;">
                <input matInput class="form-control seachInput" [formControl]="CurrQtyFilter" placeholder="Credit"
                  style="border: none; border-bottom: 1px solid; width: 120px; font-size: 14px;">
              </div>
            </th>
            <td mat-cell *matCellDef="let item" (click)="(isEnableBatches && item.BatchType != 0) ? openStrBatchQtyMdl(qtyStrBatch, item.StoreBatches, item.ItemID,item.Batches) : openQty(qtyEdit, item.StoreBatches, item.ItemID)"
              style="text-align: right; cursor: pointer !important; color: {{item.CurrQty < item.MinStockQty ? 'red' :'SKU'}};">
              {{item.CurrQty }}</td>
          </ng-container>

          <ng-container matColumnDef="SKU">
            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef>
              <label style="cursor: pointer;display: none;">Unit</label>
              <div class="filter" floatLabel="never" style="display: none;">
                <input matInput class="form-control seachInput" [formControl]="SKUFilter" placeholder="Closing"
                  style="border: none; border-bottom: 1px solid; width: 120px; font-size: 14px;">
              </div>
            </th>
            <!-- <td mat-cell *matCellDef="let item" (click)="item.BatchType == 0 ? openQty(qtyEdit, item.StoreBatches, item.ItemID) : ''"
              style="text-align: left; cursor: pointer; width: 5%;padding-left: 5px;color: {{item.CurrQty < item.MinStockQty ? 'red' :''}};">
              {{item.SKU}}</td> -->
              <td mat-cell *matCellDef="let item" (click)="(isEnableBatches && item.BatchType != 0) ? openStrBatchQtyMdl(qtyStrBatch, item.StoreBatches, item.ItemID,item.Batches) : openQty(qtyEdit, item.StoreBatches, item.ItemID)"
              style="text-align: left; cursor: pointer; width: 5%;padding-left: 5px;color: {{item.CurrQty < item.MinStockQty ? 'red' :''}};">
              {{item.SKU}}</td>
          </ng-container>

          <ng-container matColumnDef="DefStockRate">
            <th [style.display]="(isRateView ? '' : 'none')" class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" style="text-align: right; cursor: pointer;">
              <label style="cursor: pointer;">Rate</label>
              <!-- <div class="filter" floatLabel="never" style="width: 90%; display: none;">
                <input matInput class="form-control" [formControl]="StockValueFilter" placeholder="isHead"
                  style="border: none; border-bottom: 1px solid; font-size: 14px;">
              </div> -->
            </th>
            <td [style.display]="(isRateView ? '' : 'none')" mat-cell *matCellDef="let item" style="text-align: right; cursor: pointer;"
              (click)="openItemEidt(productEdit, item);"> 
              <!-- Ruppes or Doller -->
              <span *ngIf="myCurrency.code == 'INR'">₹ {{item.DefStockRate | lacFormat : 1}}</span>
              <span *ngIf="myCurrency.code != 'INR'">{{item.DefStockRate | currency}}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="TotalValue">
            <th [style.display]="(isRateView ? '' : 'none')" class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
            arrowPosition="before" style="text-align: right; cursor: pointer;">
              <label style="cursor: pointer;">Value</label>
              <!-- <div class="filter" floatLabel="never" style="width: 90%; display: none;">
                <input matInput class="form-control" [formControl]="DefStockRateFilter" placeholder="isHead"
                  style="border: none; border-bottom: 1px solid; font-size: 14px;">
              </div> -->
            </th> 
            <td [style.display]="(isRateView ? '' : 'none')" mat-cell *matCellDef="let item" style="text-align: right; cursor: pointer;"
              (click)="openItemEidt(productEdit, item);">
              <span *ngIf="myCurrency.code == 'INR'">₹ {{ (ValnMethod == 1 ? item.ValStdCost : (ValnMethod == 2 ? item.ValLPP : (ValnMethod == 3 ? item.ValHistAvg : '0'))) | lacFormat : 1}}</span>
              <span *ngIf="myCurrency.code != 'INR'">{{ (ValnMethod == 1 ? item.ValStdCost : (ValnMethod == 2 ? item.ValLPP : (ValnMethod == 3 ? item.ValHistAvg : '0'))) | currency}}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="Actions">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef style="text-align: right;">
              <div class="filter" floatLabel="never" style="width: 90%; display: none;">
                <input matInput class="form-control" [formControl]="DefStockRateFilter" placeholder="isHead"
                  style="border: none; border-bottom: 1px solid; font-size: 14px;">
              </div>
            </th>
            <td mat-cell *matCellDef="let item" style="text-align: right;">
              <div class="lableBtnOrange inLneBlk" style="cursor: pointer;" (click)="openItemEidt(productEdit, item);" *ngIf="right.InvMstrs">
                <i class="fa fa-pencil" aria-hidden="true"></i>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let item; columns: displayedColumns"></tr>
          <tr class="mat-row" *matNoDataRow style="text-align: left;">
            <td class="mat-cell" colspan="4" style="background-color: #fff;">
              <div class="nrf" style="border-radius: 3px;">No stock items found.</div>
            </td>
          </tr>
        </table>
        <mat-paginator [pageSize]="10" [pageSizeOptions]="[5,10, 20]">
        </mat-paginator>
      </div>
    </div>

    <!-- Show cards if no item is added to inventory -->
    <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="!showItemList && !isdataFilter" style="margin-top: 10px;">
      <div class="col-md-12 col-sm-12 col-xs-12 pad0">
        <div class="col-md-12 col-sm-12 col-xs-12 pad0 bzSection" 
        style="border-radius: 3px; padding: 10px;">
          <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="margin-bottom: 10px;">
            <span class="nrf" style="font-size: 15px; border-radius: 3px; padding: 6px 12px; color: #333;">No stock items found.</span>
            </div>
          <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmMainDiv" *ngIf="right.InvMstrs || right.InvCfg">
            <!-- Add item manually -->
            <div class="col-md-3 col-sm-3 col-xs-3 pad0 noItmDiv" *ngIf="right.InvMstrs">
              <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmTtl">
                <span>Add Item Manually</span>
              </div>
              <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmSbTtl">
                <span> Add first stock item manually easily.</span>
              </div>
              <span *ngIf="right.InvMstrs" class="btn orangeButton" (click)="open(mymodal)"
              style="margin-right: 5px; font-size: 13px !important; color:#fff; border-radius: 3px; position: absolute; bottom: 10px;">
                <i class="zmdi zmdi-plus" aria-hidden="true" style="position: relative; top: 0px; font-size: 16px"></i>
                <span style="margin-left: 7px;">Add Item</span>
              </span>
            </div>
            <!-- Import item from excel -->
            <div class="col-md-3 col-sm-3 col-xs-3 pad0 noItmDiv" *ngIf="right.InvMstrs">
              <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmTtl">
                <span>Import Items from Excel</span>
              </div>
              <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmSbTtl">
                <span>Import list of Items through Excel by downloading our template.</span>
              </div>
              <span *ngIf="right.InvMstrs" (click)="importItems(itemimport)" class="btn darkBlueButton" title="Import Items"
              style="cursor: pointer; margin-right: 5px; line-height: 19px; padding: 5px 9px !important;">
                <span style="font-weight: bold;"><i class="zmdi zmdi-arrow-left-bottom" aria-hidden="true"></i> Import Items</span>
              </span>
            </div>
            <!-- Configuration -->
            <div class="col-md-3 col-sm-3 col-xs-3 pad0 noItmDiv" *ngIf="right.InvCfg">
              <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmTtl">
                <span>Configure Data for Stock</span>
              </div>
              <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmSbTtl">
                <span> Configure data for stock like units, Stores, HSN/SAC, Categories etc.</span>
              </div>
              <span class="btn darkBlueButton fntSz" *ngIf="right.InvCfg" [routerLink]="['/Settings']" title="Settings"
              style="cursor: pointer; line-height: 19px; padding: 5px 8px !important;">
                <span> <i class="fa fa-cog" aria-hidden="true"></i> Inventory Settings</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- <div (click)="open(mymodal)" class="col-md-12 col-12 col-sm-12 pad0" style="padding: 15px; margin-top: 15px; border-radius: 3px;" *ngIf="Items.length == 0 && !isdataFilter">
      <div class="nrf brdrRadius3" style="cursor: pointer;">Click here to add an item.</div>
    </div> -->
    <div style="padding-left: 20px; padding-bottom: 20px; margin-top: 15px;" *ngIf="Items.length == 0 && isdataFilter">
      <div class="nrf brdrRadius3" (click)="open(mymodal)" style="cursor: pointer; display: inline-block;">No data matching the filter</div>
    </div>

    <div class="col-md-12 col-sm-12 col-xs-12" style="margin-top: 10px;padding-left: 15px;margin-bottom: 15px;">
        <a href="https://biziverse.com/support/support.html?abt=inventory" target="_blank" class="trngDarkBlueBtn brdrRadius3" style="text-decoration: none; display: inline-block;">
          <i class="zmdi zmdi-help-outline" style="margin-right: 1px; font-size: 16px; vertical-align: inherit;position: relative;top: 2px;"></i> Training Materials
        </a>
        <span *ngIf="!showLearningMaterial && showOnBoarding" style="margin-left: 10px;" (click)="openHelpPage(12)" class="trngDarkBlueBtn">
          <i class="fa fa-question" style="margin-right: 5px; vertical-align: initial; font-size: 16px;"></i> Need Help
        </span>
        <span class="trngDarkBlueBtn brdrRadius3" style="margin-left: 10px; margin-right: 10px; display: inline-block;" *ngIf="showUpgrade && isAdmin" (click)="openUpgradeForInventory(8, 'in')">
            <i class="zmdi zmdi-trending-up" style="margin-right: 5px; vertical-align: middle; font-size: 18px; margin-top: -1px;"></i> Upgrade Stock Quota
        </span>
        <span (click)="openTrngModal()" class="trngDarkBlueBtn" style="margin-left: 10px;">
          <i class="fa fa-youtube-play" style="margin-right: 5px; vertical-align: initial; font-size: 16px;"></i> Watch Training
        </span>
        </div>
    </div>

  <!-- <div class="nrf">This feature is under development.</div> -->
</div>


<div class="container-fluid padMob bg  mobView bggray" style="padding-left: 15px; padding-right: 0px; background-color: #f8f8f8;">
  <div class="row ">
    <div class="col-md-12 col-12 col-sm-12 pad0 padHeder" style="padding-bottom: 0px;">
      <div class="col-md-6 col-6 col-sm-6 pad0 inLneBlk">
        <h4 style="font-size: 30px;text-shadow: 2px 2px 3px rgb(0 0 0 / 20%);" class="newHeader"> Inventory</h4>
      </div>
      <span class="btn darkBlueButton" 
              style="margin-right: 15px !important; float: right; position: relative; padding: 2px 9px; top: 1px;" 
              (click)="backToHomeBtn()">
                  <i class="zmdi zmdi-arrow-left" style="margin-right: 5px;"></i>Back
      </span>
      <span class="darkBlueButton mobileView" style="margin-right: 8px !important; margin-top: 1px; float: right; font-size: 14px; cursor: pointer; position: relative; {{show.search ? 'background-color: #fff !important; color: #15340a !important;' : ''}}" (click)="toggleSearch()">
        <i class="fa fa-search"></i>
      </span>
        <!-- <div class="col-md-6 col-6 col-sm-6 inLneBlk txtRight" (click)="backToHomeBtn()">
          <i class="fa fa-bars" style="font-size: 20px;"></i>
        </div> -->
    </div>
    <div [style.display]="show.search ? 'block' : 'none'" class="col-md-12 col-12 col-sm-12 pad0" style="padding: 10px 30px 0px 15px;">
      <div class="input-icons search">
        <span class="fa fa-search" style="top: 17px !important;"></span>
        <input #inputStockSearch id="mySearch" class="form-control formCtlFltr brdrRadius3" [(ngModel)]="search" placeholder="Search"
          style="padding-left: 35px !important; box-shadow: none; border: 1px solid #e4e4e4 !important; width: 100%; float: left; background-color: white !important;"
          type="text">
      </div>
    </div>
    <div class="col-md-12 col-12 col-sm-12 pad0 padHeder" style="padding-top: 10px; padding-bottom: 0px;">
      <div style="display: flex; justify-content: start; align-items: center; column-gap: 8px; margin-bottom: 10px; flex-wrap: wrap; padding: 0px 15px 0px 0px; gap: 10px;">
        <span *ngIf="right.InvMstrs">
          <span class="btn orangeButton font13" (click)="open(mymodal)">
            <span style="margin-right: 8px;">
              <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 16px;"></i>
            </span>
            <span>Add Item</span>
          </span>
        </span>

        <span *ngIf="right.InvXns">
          <span class="btn orangeButton font13" (click)="openTransaction(1)">
            <span style="margin-right: 8px;">
              <i class="fa fa-sign-in" aria-hidden="true" style="font-size: 16px; position: relative; top: 1px;"></i>
            </span>
            <span>In / Receive</span>
          </span>
        </span>

        <span *ngIf="right.InvXns">
          <span class="btn orangeButton font13" (click)="openTransaction(0)">
            <span style="margin-right: 8px;">
              <i class="fa fa-sign-out" aria-hidden="true" style="font-size: 16px; position: relative; top: 1px;"></i>
            </span>
            <span>Out / Issue</span>
          </span>
        </span>

        <span class="btn btn-darkBlue fntSz brdrRadius3" *ngIf="right.InvCfg" [routerLink]="['/Settings']" title="Settings"
          style="cursor: pointer; line-height: 20px;
          padding: 5px 10px;">
          <span>
            <i class="fa fa-cog"aria-hidden="true"></i>
          </span>
        </span>

        <span class="btn btn-darkBlue fntSz brdrRadius3" (click)="toggleFilters()" title="Filter"
          style="cursor: pointer; line-height: 20px; padding: 5px 10px; {{show.filters ? 'background-color: #fff !important; color: #15340a !important;' : ''}}">
          <span>
            <i class="fa fa-filter" aria-hidden="true"></i> ({{getFilterCount()}})
          </span>
        </span>
      </div>


      <div style="display: flex; justify-content: start;  align-items: center; gap: 10px; margin-bottom: 10px; flex-wrap:wrap;">
        <span class="label greenBadge-wb fntSz" style="padding: 5px 7px; border-radius: 3px; background: #fff; border: 1px solid; color: 4caf50;" *ngIf="totalValue > 0 && isRateView">
            Total Value: <span style="font-weight: bold;">₹ {{totalValue | lacFormat : 2}}</span>
        </span>
        <span class="label greenBadge-wb fntSz"
          style="padding: 5px 7px; border-radius: 3px; float: right; background: #fff; border: 1px solid; color: 4caf50;"
          *ngIf="ValnMethod == 1 || ValnMethod == 2 || ValnMethod == 3"><span>
            Valuation : {{ValnMethod == 1 ? 'Standard Cost' : (ValnMethod == 2 ? 'Last Purchase Price' : (ValnMethod == 3 ? 'Historical Average' : ''))}}</span>
        </span>
      </div>

      <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="selectedTags.length>0" style="display: flex; justify-items: start; flex-wrap: wrap; column-gap: 8px; row-gap: 4px; margin-bottom: 10px; padding-left: 0; padding-right: 0;">
        <div style="display: inline-block; border: 1px solid #ddd; padding: 5px 10px 3px; font-size: 13px; padding-top: 3.5px; border-radius: 3px; background:rgb(31 98 142 / 10%) !important; color:#15304a" *ngFor="let x of selectedTags; let i = index">
          <span>{{x}}</span>
          <span style="margin-left: 5px; cursor: pointer;" (click)="removeTagSearchNew(i)">
            <i class="zmdi zmdi-close"></i>
          </span>
        </div>
      </div>

      <div [style.display]="show.filters ? 'block' : 'none'" style="margin-bottom: 10px; margin-right: 15px;">
        <div style="display: flex; justify-content: start; align-items: center; column-gap: 8px; margin-right: 15px; margin-bottom: 10px; max-width: 360px;">
          <input type="text" class="form-control formCtlFltr brdrRadius3" list="Tags" placeholder="Search by Tag" style="border: 1px solid #BCC2C9 !important; display: inline-block; width: 100%;background-color: white !important; padding-left:10px;" [(ngModel)]="itemTag.search">
          <datalist id="Tags" tabindex="1">
            <option *ngFor="let i of tag" value="{{i}}">
          </datalist>
          <!-- <div>
            <i class="zmdi zmdi-plus orangeText"
            style="font-size: 20px; vertical-align: middle; cursor: pointer;"
            (click)="getTagSearchData(1)"></i>
          </div> -->
          <span class="greenBadge brdrRadius3" style="cursor: pointer; line-height: 20px; padding: 5px 10px;" (click)="filterApply()">
            <i class="zmdi zmdi-check"></i>
          </span>
        </div>
        <!-- First row: Category and Sub-Category filters -->
        <div style="display: flex; justify-content: start; align-items: center; column-gap: 8px; margin-bottom: 10px; max-width: 360px;">
          <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 50%; max-width: 180px;"
                  id="txtItem" [(ngModel)]="data.categoryID" tabindex="1" (change)="filterCategory()">
                  <option [value]="0">All Categories</option>
                  <option *ngFor="let a of categories" [value]="a.cid">{{a.cnm}}</option>
          </select>
          
          <select [disabled]="subCategoryList.length == 0" class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" 
                  style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 50%; max-width: 180px;"
                  [(ngModel)]="data.SubCategoryID" tabindex="1" (change)="filterSubCategory()">
                  <option [value]="0">All Sub-Categories</option>
                  <option *ngFor="let x of subCategoryList" [value]="x.sid">{{x.snm}}</option>
          </select>
        </div>
        <div style="display: flex; justify-content: start; align-items: center; column-gap: 8px; margin-bottom: 10px; max-width: 360px;">
          <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" 
                  style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 50%; max-width: 180px;"
                  [(ngModel)]="selected.stockType" 
                  tabindex="1" 
                  (change)="filterStockItems()">
            <option [value]="0">All Non-Zero Stocks</option>
            <option [value]="1">All Stock Items</option>
            <option [value]="2">Understock Items Only</option>
          </select>
          <!-- Importance Filter -->
          <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 50%; max-width: 180px;" [(ngModel)]="selected.imp" (change)="typeFilter(6)">
            <option value="3">All Importance Levels</option>
            <option value="0">Low</option>
            <option value="2">Normal</option>
            <option value="1">High</option>
          </select>
        </div>
        <div style="display: flex; justify-content: start; align-items: center; column-gap: 8px; margin-bottom: 10px; max-width: 360px;">
          <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" 
                  style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 50%; max-width: 180px;"
                  [(ngModel)]="selectedStatus"
                  (change)="typeFilter(selected.stockType)">
            <option value="all">All Items</option>
            <option value="active">Active Items</option>
            <option value="inactive">Inactive Items</option>
          </select>
          <select class="form-control font12 formCtlFltr BzBgwhite" style="width: 50%; max-width: 180px;"
            [(ngModel)]="filter" (change)="typeFilter(filter)">
            <option [value]="0">All Types</option>
            <option [value]="1">Products</option>
            <option [value]="2">Materials</option>
            <option [value]="3">Spares</option>
            <option [value]="4">Assemblies</option>
          </select>
        </div>
        <!-- All Stores -->
         <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 50%; max-width: 180px;" [(ngModel)]="storeId" (change)="changeStore()">
          <option value="0" *ngIf="storeList.length == cntAllStores">All Stores</option>
          <option *ngFor="let s of storeList" [ngValue]="s.StrID">{{s.sNm}}</option>
        </select>
      </div>
      <!-- <span class="label darkBlueBadge fntSz bgwhite darkBlueBrdr brdrRadius3" style="cursor: pointer; display: inline-block; width: 50%;"><label
          style="margin-bottom: 0px; cursor: pointer;"><input type="checkbox" class="chkbox-darkblue chkBox" (change)="filterDepleted()"
            [(ngModel)]="depletedItems"> Show Depleted Items</label></span> -->

      <!-- <span class="label darkBlueBadge fntSz bgwhite darkBlueBrdr brdrRadius3"
        style="cursor: pointer; margin-left: 10px; display: inline-block; width: 30%;" title="Store"
        (click)="selectStore(storeSelect)">
          <span style="font-size: 14px; margin-right: 2px;"
          *ngIf="storeName.length!=0"><i class="zmdi zmdi-store"></i></span> {{storeName}}</span>

      <span class="label darkBlueBadge fntSz bgwhite darkBlueBrdr brdrRadius3"
        style="cursor: pointer; margin-left: 0px; display: inline-block; margin-top: 10px; width: 52%;"> <label
          style="margin-bottom: 0px; cursor: pointer;"><input type="checkbox" class="chkbox-darkblue chkBox" (change)="filterIncludeZeroqty()"
            [(ngModel)]="zeroQtyItems"> Include Zero Qty Items </label></span>

        <span *ngIf="myCurrency.code == 'INR' && isRateView" class="label greenBadge fntSz bgwhite brdrRadius3 greenBrdr"
          style="cursor: pointer; margin-left: 10px; margin-top: 10px; display: inline-block;">₹ {{totalValue | lacFormat: 0}}
        </span>
      
        <span *ngIf="myCurrency.code != 'INR' && isRateView" class="label greenBadge fntSz bgwhite brdrRadius3 greenBrdr"
          style="cursor: pointer; margin-left: 10px; margin-top: 10px; display: inline-block;"> {{totalValue | currency}}
        </span> -->
    </div>
 <!-- <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite padHeder" style="padding: 20px 30px 15px 15px;">
      <div class="input-icons search">
        <span class="fa fa-search" style="top: 30px !important;"></span>
        <input class="form-control formCtlFltr brdrRadius3" [(ngModel)]="search" placeholder="Search"
          style="padding-left: 35px !important; padding: 18px;  box-shadow: none; border: 1px solid #e4e4e4 !important; width: 84%; float: left;"
          type="text">
        <span *ngIf="right.InvMstrs">
          <span class="label darkBlueBadge brdrRadius3 " (click)="open(mymodal)"
              style="top: 2px; cursor: pointer; margin-left: 15px; position: relative; bottom: 5px; padding: 4px 12px 10px 12px; font-size: 11px; background: #e88421 !important; color: #fff !important"><i
              class="zmdi zmdi-plus" aria-hidden="true"
              style="position: relative; top: 4px; font-size: 22px"></i>
            </span>
        </span> 
      </div>
    </div> -->
    <div class="col-md-12 col-12 col-sm-12 pad0">
      
      <div *ngIf="Items.length == 0" class="col-md-12 col-sm-12 col-xs-12">
        <span class="nrf" style="font-size: 15px; border-radius: 3px; padding: 6px 12px; color: #333;">No stock items found.</span>
        </div>
      <div class="col-md-12 col-sm-12 col-12 pad0 bgWhite pad15 marginTp font13" (click)="openItemEidt(productEdit, x);"
        *ngFor="let x of Items | filter:'ItemName,ItemCode':search">
        <div class="col-md-12 col-12 col-sm-12 pad0">
          <div class="col-md-8 col-8 col-sm-8 pad0 inLneBlk">
            <span style="font-weight: bold; color: #444;">{{x.ItemName}}</span>
          </div>
          <div class="col-md-4 col-4 col-sm-4 pad0 inLneBlk txtRight" style="color: {{x.CurrQty < x.MinStockQty ? 'red' :'SKU'}};"
          (click)="(isEnableBatches && x.BatchType != 0) ? openStrBatchQtyMdl(qtyStrBatch, x.StoreBatches, x.ItemID, x.Batches) : openQty(qtyEdit, x.StoreBatches, x.ItemID); $event.stopPropagation();">
            <span>{{x.CurrQty}} {{x.SKU}}</span>
          </div>
        </div>
        <div class="col-md-12 col-12 col-sm-12 pad0">
          <div class="col-md-8 col-8 col-sm-8 inLneBlk pad0 font12">
            <!-- <span style="color: #777;">{{x.CategoryName}}</span> -->
             <!-- Itemcode -->
             <div  style="font-size: 12px; color: grey;">
              # {{x.ItemCode}}
          </div> 
          </div>
          <div class="col-md-4 col-4 col-sm-4 inLneBlk pad0 txtRight font12">
            <span *ngIf="myCurrency.code == 'INR' && isRateView" style="color: darkgreen;">₹ {{ (ValnMethod == 1 ? x.ValStdCost : ValnMethod == 2 ? x.ValLPP : ValnMethod == 3 ? x.ValHistAvg : '0') | lacFormat : 0}}</span>
            <span *ngIf="myCurrency.code != 'INR' && isRateView" style="color: darkgreen;"> {{ (ValnMethod == 1 ? x.ValStdCost : ValnMethod == 2 ? x.ValLPP : ValnMethod == 3 ? x.ValHistAvg : '0') | currency}}</span>
          </div>
        </div>
        <div class="col-md-12 col-12 col-sm-12 pad0">
          <!-- <div class="col-md-8 col-8 col-sm-8 inLneBlk pad0">
                    <span style="color: #777;">{{x.cmpName}}</span>
                </div>
                <div class="col-md-4 col-4 col-sm-4 inLneBlk pad0 txtRight">
                    <span style="color: #777;">{{x.wipNo}}</span>
                </div> -->
              <div class="darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite" *ngIf="x.CN && x.CN != '-'" style="margin: 5px 5px 0px 0px; font-size: 12px; padding: 3px 10px;">
                  {{x.CN}}
              </div>
              <div class="darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite" *ngIf="x.SC && x.SC != '-'" style="margin: 5px 5px 0px 0px; font-size: 12px; padding: 3px 10px;">
                  {{x.SC}}
              </div>
              <div class="darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite" *ngIf="x.Imp >= 0" style="margin: 5px 5px 0px 0px; font-size: 12px; padding: 3px 10px;">
                {{x.ImpName}}
              </div>
          <div class="lableBtnOrange inLneBlk" style="border-radius: 50%;display:none"
            (click)="openItemEidt(productEdit, x);">
            <i class="fa fa-pencil" aria-hidden="true"></i>
          </div>
        </div>
      </div>

      <!-- Show cards if no item is added to inventory -->
      <div class="col-md-12 col-sm-12 col-xs-12 pad0" *ngIf="!showItemList" style="margin-top: 10px;">
        <div class="col-md-12 col-sm-12 col-xs-12 pad0">
          <div class="col-md-12 col-sm-12 col-xs-12 pad0 bzSection" style="border-radius: 3px; padding: 10px;">
            
            <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmMainDiv">
              <!-- Add item manually -->
              <div class="col-md-3 col-sm-3 col-xs-3 pad0 noItmDiv">
                <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmTtl">
                  <span>Add Item Manually</span>
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmSbTtl">
                  <span> Add first stock item manually easily.</span>
                </div>
                <span *ngIf="right.InvMstrs" class="btn orangeButton" (click)="open(mymodal)"
                style="margin-right: 5px; font-size: 13px !important; color:#fff; border-radius: 3px;">
                  <i class="zmdi zmdi-plus" aria-hidden="true" style="position: relative; top: 0px; font-size: 16px"></i>
                  <span style="margin-left: 7px;">Add Item</span>
                </span>
              </div>
              <!-- Import item from excel -->
              <div class="col-md-3 col-sm-3 col-xs-3 pad0 noItmDiv">
                <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmTtl">
                  <span>Import Items from Excel</span>
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmSbTtl">
                  <span>Importing items from Excel facility is available in Desktop.</span>
                </div>
                <!-- <span *ngIf="right.InvMstrs" (click)="importItems(itemimport)" class="btn darkBlueButton" title="Import Items"
                style="cursor: pointer; margin-right: 5px; line-height: 19px; padding: 5px 9px !important;">
                  <span style="font-weight: bold;"><i class="zmdi zmdi-arrow-left-bottom" aria-hidden="true"></i> Import Items</span>
                </span> -->
              </div>
              <!-- Configuration -->
              <div class="col-md-3 col-sm-3 col-xs-3 pad0 noItmDiv">
                <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmTtl">
                  <span>Configure Data for Stock</span>
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12 pad0 noItmSbTtl">
                  <span> Configure data for stock like units, Stores, HSN/SAC, Categories etc.</span>
                </div>
                <span class="btn darkBlueButton fntSz" *ngIf="right.InvCfg" [routerLink]="['/Settings']" title="Settings"
                style="cursor: pointer; line-height: 19px; padding: 5px 8px !important;">
                  <span> <i class="fa fa-cog" aria-hidden="true"></i> Inventory Settings</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-12 col-sm-12" style="padding-top: 10px;">
          <span class="trngDarkBlueBtn brdrRadius3" style="text-decoration: none; margin-right: 10px; font-size: 14px; display: inline-block;" *ngIf="showUpgrade && isAdmin" (click)="openUpgradeForInventory(8, 'in')">
            <i class="zmdi zmdi-trending-up" style="margin-right: 5px; vertical-align: inherit; font-size: 18px; margin-top: -1px;"></i> Upgrade Stock Quota
        </span>
      </div>
    </div>
  </div>

  <!-- Learning Materials -->
  <div *ngIf="!showLearningMaterial && showOnBoarding" style="margin-top: 10px;">
    <span (click)="openHelpPage(12)" class="trngDarkBlueBtn">
      <i class="fa fa-question" style="margin-right: 5px; vertical-align: initial; font-size: 16px;"></i> Need Help
    </span>
    <span (click)="openTrngModal()" class="trngDarkBlueBtn" style="margin-left: 10px;">
      <i class="fa fa-youtube-play" style="margin-right: 5px; vertical-align: initial; font-size: 16px;"></i> Watch Training
    </span>
  </div>
</div>

<!-- <div class="float" title="Add Item" style="cursor: pointer;" (click)="open(mymodal)" *ngIf="right.InvMstrs">
  <i class="fa fa-plus my-float"></i>
</div> -->

<!--Voucher Entry Modal-->
<ng-template #mymodal let-modal>

  <!--Body-->
  <div class="modal-body" style="padding: 0px;">
    <app-item-entry></app-item-entry>
  </div>
</ng-template>

<!-- Product Edit Modal -->
<ng-template #productEdit let-modal>
  <!--Body-->
  <div class="modal-body" style="padding: 0px;">
    <app-product-detail [ItemID]="ItemID"></app-product-detail>
  </div>
</ng-template>

<!-- Store Selection Modal -->
<ng-template #storeSelect let-modal>
  <app-select-store></app-select-store>
</ng-template>

<!-- Edit Group/Ledger -->
<ng-template #qtyEdit let-modal>
  <!--Header-->
  <div class="modal-header" style="border: none;">
    <div class="col-md-12 col-sm-12 col-12">
      <div class="row">
        <div class="col-md-9 col-sm-10 col-10" style="padding-left: 0px;">
          <h5 class="modal-title"><span id="ApntmntHdr">Stock Reconciliation - {{itemName}}</span></h5>
        </div>
        <div class="col-md-3 col-sm-2 col-2" style="padding: 0px;">
          <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="modal.dismiss('Cross click')"></i>
        </div>
      </div>
    </div>
  </div>
  <!--Body-->
  <div class="modal-body">
    <div class="col-md-12 col-sm-12 col-12" style="padding: 0px;">
      <label>Stores</label>
      <div *ngFor="let s of selectedStoreQty; let i = index;">
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-bottom: 10px;">
          <div class="col-md-6 col-sm-6 col-6" style="display: inline-block; padding: 0px; font-size: 14px;">
            {{s.name}}
          </div>
          <div class="col-md-6 col-sm-6 col-6"
            style="display: inline-block; padding: 0px; text-align: right; font-size: 14px;">
            <div style="display: inline-block; margin-right: 10px;" *ngIf="!s.isEdit">{{s.qty}} {{s.unit}}</div>
            <div style="display: inline-block; width: 75%; margin-right: 10px;" *ngIf="s.isEdit">
              <input type="text" class="form-control"
                style="height: 20px; text-align: right; width: 60%; display: inline-block;" [(ngModel)]="s.qty"
                (keyup)="enterQty(s)"> {{s.unit}}
            </div>
            <div class="inLneBlk editBtn brdrRadius3" *ngIf="!s.isEdit" (click)="changeQty(i);"
              style="cursor: pointer; display: inline-block;">
              <i *ngIf="right.InvXns" class="fa fa-pencil" aria-hidden="true"
                style="font-size: 13px; position: relative; bottom: 1.1px;"></i>
            </div>
            <div class="inLneBlk doneBtn brdrRadius3" *ngIf="s.isEdit" (click)="saveReconcile(s)"
              style="cursor: pointer; display: inline-block;">
              <i class="fa fa-check" aria-hidden="true" style="font-size: 13px; position: relative; bottom: 1.1px;"></i>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
  <!--Footer-->
  <div class="" style="padding: 15px; border: none; text-align: left; float: left; padding-top: 0px;">

  </div>
</ng-template>



<!-- Store and batches wise reconsolition -->
<ng-template #qtyStrBatch let-modal>
  <!--Header-->
  <div class="modal-header" style="border: none;">
    <div class="col-md-12 col-sm-12 col-12">
      <div class="row">
        <div class="col-md-9 col-sm-10 col-10" style="padding-left: 0px;">
            <div class="modal-title" style="display: inline-block;">
              <span id="ApntmntHdr">Stock Reconciliation - {{itemName}}</span>
            </div>
            <div class="label orangeBadge-wb fntSz"style="padding: 5px 9px; display: inline-block; margin-left: 20px; line-height: 18px;"
            *ngIf="Items.length  > 0">Total Stock : {{totalStkQty }} {{totalStkUnit}}
            </div>
        </div>
        <div class="col-md-3 col-sm-2 col-2" style="padding: 0px;">
          <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeStrBtcModal();"></i>
        </div>
      </div>
    </div>
  </div>
  <!--Body-->
  <div class="modal-body">
    <!-- new with batch -->
    <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; display: inline-block;">
      <div class="col-md-6 col-sm-6 col-xs-6 edtStrMdl brdrRadius3" style="background-color: #fff; overflow: auto;
        padding: 10px; border: 1px solid #e88421; display: inline-block; margin-right: 15px;">
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px;">
          <div style="color:#e88421">Stores</div>
          <div class="col-md-12 col-sm-12 col-xs-12" style="height: 302px; overflow-y: auto;padding: 0px;padding-top: 13px;">
            <div *ngFor="let s of selectedStoreQty; let i = index;">
              <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-bottom: 10px;">
                <div class="col-md-6 col-sm-6 col-6" style="display: inline-block; padding: 0px; font-size: 14px;">
                  {{s.name}}
                </div> 
                <div class="col-md-6 col-sm-6 col-6"  style="display: inline-block; padding: 0px; text-align: right; font-size: 14px;">
                  <!-- <div style="display: inline-block; margin-right: 10px;" *ngIf="!s.isEdit">{{s.qty}} {{s.unit}}</div> -->
                  <div style="display: inline-block; width: 75%; margin-right: 10px;">
                    <input type="text" class="form-control"
                      style="height: 20px; text-align: right;background: inherit; width: 60%; display: inline-block;" [(ngModel)]="s.qty"
                      (change)="prcnQty(s)" (keyup)="enterQty(s)"> {{s.unit}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-sm-6 col-xs-6 edtBatchMdl brdrRadius3" style="padding:0px; background-color: #FFF; overflow: auto;
       border: 1px solid #15304A; display: inline-block;">
          <app-batch-selection ></app-batch-selection>
      </div>
    </div>
  </div>

  <!--Footer-->
  <div class="" style="padding: 15px; border: none; text-align: left; float: left; padding-top: 0px;">
      <span class="btn-green brdrRadius3" style="padding: 2px 8px; font-size: 14px; font-weight: 500;" (click)="fn_StrBatchesReconcile(s)" >
        <i class="fa fa-check" style="margin-right: 5px;"></i> Save
    </span>
  </div>
</ng-template>



<!-- Tag search -->
<ng-template #tagSearch let-modal>
  <!--Header-->

  <div class="col-md-12 col-sm-12 col-12">
    <div class="row">
      <div class="col-md-9 col-sm-10 col-10" style="padding: 15px; padding-bottom: 0px;">
        <h4> Filter</h4>
      </div>
      <div class="col-md-3 col-sm-2 col-2" style="padding: 15px; padding-bottom: 0px;">
        <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="modal.dismiss('Cross click')"></i>
      </div>
    </div>
  </div>

  <!--Body-->
  <div class="modal-body">
    <div class="col-md-12 col-sm-12 col-12" style="padding-left: 0px;">
      <!-- <div *ngFor="let s of selectedStoreQty"> -->
      <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-bottom: 10px;">
        <span>
          <!-- Tag List -->
          <!-- <select class="form-control" id="Tags" (click)="chagetagValue()" [(ngModel)]="itemTag.search" tabindex="1" placeholder="Select Voucher Type">
            <option label="Select Tag"></option>
            <option *ngFor="let i of tag" [ngValue]="i.tag">{{i}}</option>
          </select> -->
          <input type="text" class="form-control" list="Tags" placeholder="Search by Tag"
            style="border: 1px solid #BCC2C9 !important; width: 90%; display: inline-block;" [(ngModel)]="itemTag.search">

          <datalist id="Tags" tabindex="1">
            <option *ngFor="let i of tag" value="{{i}}">
          </datalist>

          <i class="zmdi zmdi-plus orangeText"
            style="font-size: 20px; vertical-align: middle; cursor: pointer; margin-left: 10px;"
            (click)="getTagSearchData(1)"></i>

          <!-- Category List -->
          <select style="border: 1px solid #BCC2C9 !important; width: 96%; margin-top: 10px;" class="form-control" id="txtItem" [(ngModel)]="data.categoryID"
            tabindex="1" (change)="filterCategory()">
            <option [value]="0">Select Category</option>
            <option *ngFor="let a of categories" [value]="a.cid">{{a.cnm}}</option>
          </select>

          <!-- <input type="text"  list="categoryList" id="txtItem" class="form-control" tabindex="1" placeholder="Select Category"
            title="Category" [(ngModel)]="data.category" style="width: 96%; margin-top: 10px;" (change) = "selectCategory()"/>

          <datalist id="categoryList">
              <option *ngFor="let a of categories" [value]="a.cnm"></option>
          </datalist>  -->

          <!-- sub Category List -->

          <select style="border: 1px solid #BCC2C9 !important; width: 96%; margin-top: 10px;" [disabled]="subCategoryList.length == 0"
            class="form-control subcat" id="txtItem" [(ngModel)]="data.SubCategoryID" tabindex="1"
            (change)="filterSubCategory()">
            <option [value]="0">Select Sub Category</option>
            <option *ngFor="let x of subCategoryList" [value]="x.sid">{{x.snm}}</option>
          </select>

          <!-- <input type="text"  list="subCategoryList" id="txtItem"  [disabled]="subCategoryList.length == 0" class="form-control subcat" tabindex="1" placeholder="Select Sub-Category"
             title="Category" [(ngModel)]="data.subCategory" style="width: 96%; margin-top: 10px;" (change) = "selectSubCategory()"/>

            <datalist id="subCategoryList">
              <option *ngFor="let x of subCategoryList" [value]="x.snm"></option>
            </datalist> -->


          <!-- <i class="zmdi zmdi-plus" style="margin-left: 20px; font-size: 20px; vertical-align: middle; cursor: pointer;"
            (click)="getTagSearchData(1)"></i> -->
        </span>
      </div>

      <!-- </div> -->
    </div>

    <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="selectedTags.length>0"
      style="padding-right: 0px; left: -8px; padding-left: 0px">

      <div
        style="display: inline-block; border: 1px solid #ddd; padding: 5px 10px 3px; font-size: 13px; padding-top: 3.5px; border-radius: 25px; margin-top: 5px; margin-left: 5px; background:rgb(31 98 142 / 10%) !important; color:#15304a"
        *ngFor="let x of selectedTags; let i = index">
        <span>
          {{x}}
        </span>
        <span style="margin-left: 5px; cursor: pointer;" (click)="removeTagSearch(i)">
          <i class="zmdi zmdi-close"></i>
        </span>
      </div>

      <!-- <option *ngFor="let i of selectedTags ">{{selectedTags[i]}} -->

    </div>

  </div>
  <!--Footer-->
  <div class="" style="padding: 15px; border: none; text-align: left; float: left; padding-top: 0px;">
    <span style="float: left;"><span class="btn-green brdrRadius3" (click)="filterApply()"
        style="padding:2px 12px; font-size: 13px !important; color:#fff; background:#4caf50; "><i
          class="zmdi zmdi-check" aria-hidden="true" style="position: relative; top: 3px; font-size: 18px"></i> <span
          style="margin-left: 5px;">Apply</span></span></span>
    <!-- <div class="col-md-6 col-xs-6 col-sm-6" style="padding-left: 0px;">
      <i class="btn btn-orange" >Apply</i>
    </div> -->
  </div>
</ng-template>

<!-- (click)="tagSearchItem($event)" -->

<!-- items Import Modal -->
<ng-template #itemimport let-modal>
  <app-import-items></app-import-items>
</ng-template>

<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">

</ngx-spinner>
